/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Error_Save_UserInputs */



/**
* | output |
* | --- |
* | "Couldn't save the user." |
*
* @param {User_Error_Save_UserInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_error_save_user = /** @type {((inputs?: User_Error_Save_UserInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Error_Save_UserInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Impossible d'enregistrer l'utilisateur.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se pudo guardar el usuario.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Não foi possível salvar o usuário.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Impossibile salvare l'utente.")
	return /** @type {LocalizedString} */ ("Couldn't save the user.")
});